module.exports = __webpack_public_path__ + "static/media/covid-19.ea6096f3.PNG";